import { CatalogServiceProductData } from 'src/services/catalog';
import { TrackingProductData } from 'src/tracking/common/products';

// The price of a product is always pushed to dataLayer in GBP
export const transformProductModelToProductForTracking = ({
  code,
  freeDomesticDelivery,
  isNew,
  onSale,
  salePercentage,
  partner,
  price,
  purchasable,
  title,
}: CatalogServiceProductData): TrackingProductData => ({
  code,
  freeDomesticDelivery,
  isNew,
  onSale,
  salePercentage,
  partner,
  price,
  purchasable,
  title,
});
